export default {"src":"/_next/static/media/express.3d648808.svg","height":500,"width":500,"blurWidth":0,"blurHeight":0};